import Api from './api';

/**
 * Serviço para operações de projetos
 * Integração com ProjectController do backend
 */
class ReportBuilderService {
  static async getMetricList(erp) {
    return await Api.get('/reportbuilder/getMetricList', { params: { erp } });
  }

  static async getDREData(
    erp,
    externalId,
    dimension,
    metric,
    dataini,
    datafim,
    compiledFilters,
    regimeType = 'emissao',
    dreGroupBy = undefined,
    config = undefined,
  ) {
    const payload = {
      erp: erp,
      externalId: externalId,
      dimension: dimension,
      metric: metric,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters,
      DREDateFilter: regimeType
    };

    // Envia DREGroupBy apenas quando definido (retrocompatível)
    if (dreGroupBy !== undefined && dreGroupBy !== null) {
      payload.DREGroupBy = dreGroupBy;
    }

    return await Api.post('/reportbuilder/getDREData', payload, config);
  }

  static async getDFCData(
    erp,
    externalId,
    dataini,
    datafim,
    compiledFilters,
    regimeType = 'emissao',
    config = undefined,
  ) {
    return await Api.post('/reportbuilder/getDFCData', {
      erp: erp,
      externalId: externalId,
      dimension: 0,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters,
      DFCDateFilter: regimeType
    }, config);
  }

  static async getABCData(erp, externalId, dimension, groups, cutA, cutB, dataini, datafim, compiledFilters) {
    return await Api.post('/reportbuilder/getABCData', {
      erp: erp,
      externalId: externalId,
      dimension: dimension,
      groups: groups,
      cutA: cutA,
      cutB: cutB,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters
    });
  }

  static async getVisualData(
    erp,
    externalId,
    dimension,
    metric,
    dataini,
    datafim,
    compiledFilters,
    regime,
    widgetType = undefined,
    config = undefined,
  ) {
    return await Api.post('/reportbuilder/getVisualData', {
      erp: erp,
      externalId: externalId,
      dimension: dimension,
      metric: metric,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters,
      regime: regime,
      ...(widgetType ? { widgetType } : {})
    }, config);
  }

  static async getVisualDetailData(payload, config = undefined) {
    return await Api.post('/ReportBuilder/GetVisualDetailData', payload, config);
  }

  static async getTableData(
    erp,
    externalId,
    metric,
    dimensionsArray,
    dataini,
    datafim,
    compiledFilters,
    optionsOrConfig = undefined,
    config = undefined,
  ) {
    let includeDates = false;
    let regime = undefined;
    let effectiveConfig = config;

    const looksLikeAxiosConfig =
      optionsOrConfig &&
      typeof optionsOrConfig === "object" &&
      !Array.isArray(optionsOrConfig) &&
      (Object.prototype.hasOwnProperty.call(optionsOrConfig, "signal") ||
        Object.prototype.hasOwnProperty.call(optionsOrConfig, "headers") ||
        Object.prototype.hasOwnProperty.call(optionsOrConfig, "params") ||
        Object.prototype.hasOwnProperty.call(optionsOrConfig, "timeout") ||
        Object.prototype.hasOwnProperty.call(optionsOrConfig, "baseURL"));

    if (typeof optionsOrConfig === "string") {
      regime = optionsOrConfig;
    } else if (
      optionsOrConfig &&
      typeof optionsOrConfig === "object" &&
      !Array.isArray(optionsOrConfig) &&
      (Object.prototype.hasOwnProperty.call(optionsOrConfig, "includeDates") ||
        Object.prototype.hasOwnProperty.call(optionsOrConfig, "regime"))
    ) {
      includeDates = Boolean(optionsOrConfig.includeDates);
      regime = optionsOrConfig.regime;
    } else if (looksLikeAxiosConfig && effectiveConfig === undefined) {
      effectiveConfig = optionsOrConfig;
    }

    return await Api.post('/ReportBuilder/GetTableData', {
      erp: erp,
      externalId: externalId,
      metric: metric,
      dimensions: dimensionsArray,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters,
      ...(includeDates ? { includeDates: true } : {}),
      ...(regime ? { regime } : {}),
    }, effectiveConfig);
  }

  static async getTitulosStatusData(payload, config = undefined) {
    return await Api.post('/ReportBuilder/GetTitulosStatusData', payload, config);
  }

  static async getFluxoCaixaData(
    erp,
    externalId,
    dataini,
    datafim,
    compiledFilters,
    regime = 'pagamento',
    usaSaldo = false,
    config = undefined,
  ) {
    return await Api.post('/reportbuilder/getFluxoCaixaData', {
      erp: erp,
      externalId: externalId,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters,
      regime: regime,
      usaSaldo: usaSaldo
    }, config);
  }

  static async getSaldosData(
    erp,
    externalId,
    compiledFilters,
    daysForward = 30,
    includeSolvency = false,
    dateBase = "vencimento",
    status = []
  ) {
    return await Api.post('/reportbuilder/getSaldosData', {
      erp: erp,
      externalId: externalId,
      dimensionFilters: compiledFilters,
      daysForward: daysForward,
      includeSolvency: includeSolvency,
      dateBase: dateBase,
      status: status
    });
  }

  static async getMatrixData(erp, externalId, metric, dimensionsArray, columnDimensionsArray, dataini, datafim, compiledFilters) {
    return await Api.post('/reportbuilder/getMatrixData', {
      erp: erp,
      externalId: externalId,
      metric: metric,
      dimensions: dimensionsArray,
      columnDimensions: columnDimensionsArray,
      period: {
        start: dataini,
        end: datafim
      },
      dimensionFilters: compiledFilters,
    });
  }

  static async saveTemplate(templateData) {
    return await Api.post('/reportbuilder/saveTemplate', templateData);
  }

  static async getTemplates() {
    return await Api.get('/reportbuilder/getTemplates');
  }

  static async loadTemplate(templateId) {
    return await Api.get(`/reportbuilder/getTemplate/${templateId}`);
  }

  //==============================
  // Seção de filtro de dimensão
  //==============================
   /**
   * Retorna o universo (todos os valores possíveis) para uma dimensão.
   * Ex.: [{ id:'cat_10', name:'Bebidas' }, ...]
   */
   static async getDimensionValues(erpId, externalId, dimension, config = undefined) {
    return await Api.post(`/reportbuilder/getDimensionValues`, { erp: erpId, externalId, dimension }, config);
  }
  //==============================
  // Fim da seção de filtro de dimensão
  //==============================
}

export default ReportBuilderService; 
